import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/site-layout.css';

// لینک‌های پیش‌فرض هدر — فقط تا زمانی که پاسخ /api/auth/public-settings برسد
// یا اگر پنل ادمین هنوز چیزی برای site_nav.header ذخیره نکرده باشد استفاده می‌شود.
const DEFAULT_HEADER_LINKS = [
  { id: 'journey', icon: '', image: '', labelFa: 'مراحل بازی', labelEn: 'Game Journey', href: '/about' },
  { id: 'login', icon: '', image: '', labelFa: 'ورود به سکوی ۹¾', labelEn: 'Login', href: '/portal-9-3-4' }
];

/**
 * Shared site navigation header.
 * @param {boolean} scrolled  - add scrolled glass background (for fixed nav)
 * @param {boolean} fixed     - use position:fixed (landing page); else sticky
 */
export default function SiteNav({ scrolled = false, fixed = false }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'fa';
  const isFarsi = currentLang === 'fa';

  const [showLogin, setShowLogin] = useState(false);
  const [links, setLinks] = useState(DEFAULT_HEADER_LINKS);

  useEffect(() => {
    fetch(`/api/auth/public-settings?_=${Date.now()}`)
      .then((r) => r.json())
      .then((data) => {
        if (data?.settings?.showLoginButton) setShowLogin(true);
        if (Array.isArray(data?.siteNav?.header) && data.siteNav.header.length > 0) {
          setLinks(data.siteNav.header);
        }
      })
      .catch(() => {});
  }, []);

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    localStorage.setItem('language', newLang);
    i18n.changeLanguage(newLang);
    
    // ریدایرکت به ساب‌دامنه/دامنه متناظر در محیط واقعی (غیر از لوکال‌هاست)
    const host = window.location.hostname;
    if (host !== 'localhost' && host !== '127.0.0.1') {
      let targetUrl = '';
      if (newLang === 'fa') {
        targetUrl = 'https://potterhead.ir';
      } else if (newLang === 'en') {
        targetUrl = 'https://potterheads.org';
      } else {
        targetUrl = `https://${newLang}.potterheads.org`;
      }
      window.location.href = targetUrl + window.location.pathname + window.location.search;
    }
  };

  const cls = [
    'snav',
    fixed ? 'snav--fixed' : 'snav--sticky',
    scrolled ? 'snav--scrolled' : '',
  ].filter(Boolean).join(' ');

  const logoText = isFarsi ? 'جامعه پاترهدها' : 'Potterheads Community';

  return (
    <nav className={cls} role="navigation">
      <div className="snav__inner">
        <a href="/" className="snav__logo">
          <span className="snav__logo-bolt">⚡</span>
          {logoText}
        </a>
        <div className="snav__links">
          {/* منوی کشویی تغییر زبان */}
          <div className="snav__lang-container">
            <select
              value={currentLang}
              onChange={handleLanguageChange}
              className="snav__lang-select"
              aria-label="Select Language"
            >
              <option value="fa">🇮🇷 فارسی</option>
              <option value="en">🇬🇧 English</option>
              <option value="ja">🇯🇵 日本語</option>
              <option value="de">🇩🇪 Deutsch</option>
              <option value="pt">🇵🇹 Português</option>
              <option value="fr">🇫🇷 Français</option>
              <option value="it">🇮🇹 Italiano</option>
              <option value="es">🇪🇸 Español</option>
              <option value="ko">🇰🇷 한국어</option>
              <option value="hi">🇮🇳 हिन्दी</option>
              <option value="zh">🇨🇳 中文</option>
            </select>
          </div>

          {links.map((link) => {
            // آیتم «ورود» همچنان تابع تنظیم عمومی showLoginButton است.
            if (link.id === 'login' && !showLogin) return null;
            const label = isFarsi ? link.labelFa : link.labelEn;
            const cta = link.id === 'login' ? ' snav__link--cta' : '';
            return (
              <a key={link.id} href={link.href} className={`snav__link${cta}`}>
                {link.image && (
                  <img
                     src={link.image}
                     alt=""
                     className="snav__link-icon"
                     style={link.imageWidth || link.imageHeight ? {
                       width: link.imageWidth ? `${link.imageWidth}px` : undefined,
                       height: link.imageHeight ? `${link.imageHeight}px` : undefined
                     } : undefined}
                  />
                )}
                {!link.image && link.icon && <span className="snav__link-icon">{link.icon}</span>}
                {label}
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
